import { Link } from 'react-router-dom';
import { useStaggeredAnimation } from '@/hooks/useScrollAnimation';

const contactCards = [
  {
    icon: 'ri-phone-line',
    title: 'Teléfono',
    content: '77173439',
    href: 'tel:+59177173439',
    external: false,
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'WhatsApp',
    content: 'Escribir al 77173439',
    href: 'https://wa.me/59177173439',
    external: true,
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Dirección',
    content: 'Junín 1152, atrás del Hospital Regional San Juan de Dios',
    href: null,
    external: false,
  },
  {
    icon: 'ri-time-line',
    title: 'Horarios',
    content: '24 horas, 7 días a la semana',
    href: null,
    external: false,
  },
];

export default function ContactSection() {
  const { ref, isVisible, getDelay } = useStaggeredAnimation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-100 relative overflow-hidden">
      <div className="absolute top-10 right-10 w-64 h-64 bg-accent-100/50 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          {/* Left text */}
          <div className={`lg:col-span-4 reveal-left ${isVisible ? 'is-in' : ''}`}>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-500 uppercase mb-4">
              <span className="w-8 h-px bg-primary-400" />
              Contacto
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 mb-5 leading-[1.08]">
              Estamos para <span className="italic text-primary-600">atenderte</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-7">
              Visítanos o contáctanos por teléfono o WhatsApp. Atendemos las 24 horas del día, todos los días del año.
            </p>
            <Link
              to="/contacto"
              className="group inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-line" />
              </span>
              Ver ubicación completa
              <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>

          {/* Right cards */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {contactCards.map((card, i) => {
              const cardContent = (
                <div
                  className={`group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200 hover:border-primary-300 transition-all duration-500 h-full reveal ${isVisible ? 'is-in' : ''}`}
                  style={{ transitionDelay: getDelay(i) }}
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                    <i className={`${card.icon} text-xl`} />
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-1.5">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {card.content}
                  </p>
                </div>
              );

              if (card.href) {
                return (
                  <a
                    key={card.title}
                    href={card.href}
                    target={card.external ? '_blank' : undefined}
                    rel={card.external ? 'noopener noreferrer' : undefined}
                    className="block cursor-pointer"
                  >
                    {cardContent}
                  </a>
                );
              }
              return <div key={card.title}>{cardContent}</div>;
            })}
          </div>
        </div>
      </div>
    </section>
  );
}